<template>
  <client-only>
    <el-dialog
      :model-value="visibleSync"
      :show-close="false"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      destroy-on-close
      :class="customClass"
      :top="top"
      :width="width"
      :center="center"
      :fullscreen="fullScreen"
      @close="() => $emit('click-close', false)"
    >
      <template #header="{ close, titleId, titleClass}">
        <div
          v-if="!hideHeaderTrigger"
          class="custom-header"
        >
          <h4
            :id="titleId"
            :class="titleClass"
          >
            {{ title }}
          </h4>
          <nuxt-img
            v-if="showClose"
            src="/img/basic-icon/close-black.svg"
            alt="close"
            @click="close"
          />
        </div>
      </template>
      <slot />
      <template #footer>
        <div
          v-if="!hideDoubleButton"
          class="A-dialog-double-button"
        >
          <el-button
            v-if="!hideFirstButton"
            class="A-double-first-button"
            @click="clickFirstButton"
          >
            {{ doubleFirstText }}
          </el-button>
          <el-button
            v-if="!hideSecondButton"
            class="A-double-second-button"
            :class="{'activate-second-button': activeSecondButton}"
            :disabled="!activeSecondButton"
            @click="clickSecondButton"
          >
            {{ doubleSecondText }}
          </el-button>
        </div>
        <div
          v-if="!hideSingleButton"
          class="A-dialog-single-button"
        >
          <el-button
            v-if="!hideSingleButton"
            class="A-single-button"
            type="primary"
            @click="clickSingleButton"
          >
            {{ singleText }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </client-only>
</template>

<script setup lang="ts">

const visibleSync = ref(false)

const props = withDefaults(
  defineProps<{
    customClass?: string,
    top?: string,
    width?: string,
    title?: string,
    visible?: boolean,
    closeOnClickModal?: boolean,
    closeOnPressEscape?: boolean,
    stableDialog?: boolean,
    hideHeaderTrigger?: boolean,
    hideDoubleButton?: boolean,
    hideFirstButton?: boolean,
    hideSecondButton?: boolean,
    hideSingleButton?: boolean,
    activeSecondButton?: boolean,
    center?: boolean,
    showClose?: boolean,
    doubleFirstText?: string,
    doubleSecondText?: string,
    singleText?: string,
    fullScreen?: boolean
  }>(),
  {
    customClass: '',
    top: '30vh',
    width: '436px',
    title: '',
    visible: true,
    closeOnClickModal: true,
    closeOnPressEscape: true,
    stableDialog: false,
    hideHeaderTrigger: false,
    hideDoubleButton: false,
    hideFirstButton: false,
    hideSecondButton: false,
    hideSingleButton: false,
    activeSecondButton: false,
    center: true,
    showClose: true,
    doubleFirstText: '',
    doubleSecondText: '',
    singleText: '',
    fullScreen: false
  }
)

const emits = defineEmits([
  'click-close',
  'click-first-button',
  'click-second-button',
  'click-single-button'
])

watch(() => props.visible, (newValue) => {
  visibleSync.value = newValue
})

const clickFirstButton = () => {
  emits('click-first-button')
  if (!props.stableDialog) {
    visibleSync.value = false
  }
}

const clickSecondButton = () => {
  emits('click-second-button')
  if (!props.stableDialog) {
    visibleSync.value = false
  }
}

const clickSingleButton = () => {
  emits('click-single-button')
  visibleSync.value = false
}

</script>
